/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-drawer-continue-shopping]');

    if (!button) {
      return;
    }

    var closeButton = document.querySelector('#cart-drawer [data-cart-drawer-toggle]');

    if (closeButton) {
      closeButton.click();
    }
  });

  function syncGiftWrap(cart) {
    document.querySelectorAll('[data-gift-wrap-product]').forEach(function (product) {
      var variantId = Number(product.getAttribute('data-gift-wrap-variant-id'));
      var isInCart = cart.items.some(function (item) {
        return Number(item.variant_id) === variantId;
      });
      var toggle = product.querySelector('[data-gift-wrap-toggle]');

      product.classList.toggle('is-selected', isInCart);
      if (toggle) toggle.checked = isInCart;
    });
  }

  function refreshCartInterfaces() {
    if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
  }

  // Keep the gift wrap toggle in sync after any cart change (remove, quantity, add) made by the theme
  document.addEventListener('theme:cart:added', function () {
    if (!document.querySelector('[data-gift-wrap-product]')) return;

    fetch(window.theme.routes.cart_url + '.js', {headers: {'Accept': 'application/json'}})
      .then(function (response) { return response.json(); })
      .then(syncGiftWrap)
      .catch(function () {});
  });

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-gift-wrap-toggle]');
    if (!toggle) return;

    var product = toggle.closest('[data-gift-wrap-product]');
    var variantId = Number(product.getAttribute('data-gift-wrap-variant-id'));
    if (!variantId) return;

    var toggles = document.querySelectorAll('[data-gift-wrap-toggle]');
    toggles.forEach(function (input) { input.disabled = true; });
    product.classList.add('is-loading');

    var request;
    if (toggle.checked) {
      request = fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
    } else {
      request = fetch(window.theme.routes.cart_url + '.js', {headers: {'Accept': 'application/json'}})
        .then(function (response) { return response.json(); })
        .then(function (currentCart) {
          var line = currentCart.items.findIndex(function (item) {
            return Number(item.variant_id) === variantId;
          }) + 1;
          if (!line) return {ok: true};
          return fetch(window.theme.routes.cart_change_url + '.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({line: line, quantity: 0})
          });
        });
    }

    request
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to update gift wrap');
        return fetch(window.theme.routes.cart_url + '.js', {headers: {'Accept': 'application/json'}});
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        syncGiftWrap(cart);
        refreshCartInterfaces();
      })
      .catch(function () {
        toggle.checked = !toggle.checked;
      })
      .finally(function () {
        document.querySelectorAll('[data-gift-wrap-product]').forEach(function (item) {
          item.classList.remove('is-loading');
        });
        document.querySelectorAll('[data-gift-wrap-toggle]').forEach(function (input) {
          input.disabled = false;
        });
      });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
